import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { GetTicketsTypes } from "~/API/tickets";
import type { GenericDataResponseLookupView } from "~/Core/Models";
import type { QueryResult } from "~/Store/globals";

const TicketsStore = (_set, _get) => ({
  GetTicketsTypes(): QueryResult<AxiosResponse<GenericDataResponseLookupView>> {
    return useQuery({
      placeholderData: keepPreviousData,
      queryFn: GetTicketsTypes,
      queryKey: ["GetTicketsTypes"],
    });
  },
});

export default TicketsStore;
